import { useQuery } from '@tanstack/react-query';

import { getSupplierRoomsForInternalRoom } from '~/services/AccommodationService';

export const supplierRoomsForInternalRoomQueryKeys = {
  all: ['accommodation', 'supplier-rooms-for-internal-room'] as const,
  details: () => [...supplierRoomsForInternalRoomQueryKeys.all, 'detail'] as const,
  detail: (internalRoomId: string) => [...supplierRoomsForInternalRoomQueryKeys.details(), internalRoomId] as const,
};

export function useGetSupplierRoomsForInternalRoom({
  internalRoomId,
  enabled = true,
}: {
  internalRoomId: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: supplierRoomsForInternalRoomQueryKeys.detail(internalRoomId),
    queryFn: async ({ signal }) => {
      const response = await getSupplierRoomsForInternalRoom({ internalRoomId, signal });
      return response.result;
    },
    enabled: enabled && !!internalRoomId,
  });
}
